import { Navigate, Route, Routes } from 'react-router-dom';
import { OfflineBanner } from '@/components/hud/OfflineBanner';
import { HandReplayRoute } from '@/routes/HandReplayRoute';
import { HomeRoute } from '@/routes/HomeRoute';
import { PlayRoute } from '@/routes/PlayRoute';
import { ReviewRoute } from '@/routes/ReviewRoute';
import { SettingsRoute } from '@/routes/SettingsRoute';
import { TournamentReviewRoute } from '@/routes/TournamentReviewRoute';

export default function App() {
  return (
    <>
      <OfflineBanner />
      <Routes>
        <Route path="/" element={<HomeRoute />} />
        <Route path="/play" element={<PlayRoute />} />
        <Route path="/review" element={<ReviewRoute />} />
        <Route path="/review/:tournamentId" element={<TournamentReviewRoute />} />
        <Route path="/review/:tournamentId/:handNumber" element={<HandReplayRoute />} />
        <Route path="/settings" element={<SettingsRoute />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
